
/**
 * Configuration constants for the permissions system
 */
export const PERMISSIONS_CONFIG = {
  // Cache TTL - 30 days
  TTL: 30 * 24 * 60 * 60 * 1000,
  
  // Cooldown period between refreshes - 15 seconds
  COOLDOWN_PERIOD: 15000,
  
  // Debounce delay for refresh calls - 2 seconds
  DEBOUNCE_DELAY: 2000,
} as const;
